import { defineMessages, useIntl } from 'react-intl'
import {
  Box,
  Button,
  Form,
  Heading,
  Radio,
  RadioGroup,
  Spacer,
  Text,
  Wrap,
  WrapItem
} from '@homebotapp/hb-react-component-catalog'
import { SlideOnMount } from '../../../shared/Animations'
import { Step } from '../types'
import { HomeownerDigestTrackingEventLocation } from '../../../../constants/tracking'
import { useAvmModuleContext } from '../../../shared/AvmModule/AvmModuleContext'
import { RedirectToHomeDigest } from '../../../shared/Navigation'

const MSG = defineMessages({
  heading: {
    id: 'HomePriceIndexWizard.steps.propertyType.heading',
    defaultMessage: 'What kind of home is this?'
  },
  subheading: {
    id: 'HomePriceIndexWizard.steps.propertyType.subheading',
    defaultMessage: 'Knowing more about your property helps Homebot determine its estimated value.'
  },
  submit: {
    id: 'HomePriceIndexWizard.steps.propertyType.submit',
    defaultMessage: 'Continue'
  },
  singleFamilyDetached: {
    id: 'HomePriceIndexWizard.steps.propertyType.singleFamilyDetached',
    defaultMessage: 'Single Family (Detached)'
  },
  condo: {
    id: 'HomePriceIndexWizard.steps.propertyType.condo',
    defaultMessage: 'Condo'
  },
  townhouse: {
    id: 'HomePriceIndexWizard.steps.propertyType.townhouse',
    defaultMessage: 'Townhouse'
  },
  apartment: {
    id: 'HomePriceIndexWizard.steps.propertyType.apartment',
    defaultMessage: 'Apartment'
  },
  duplex: {
    id: 'HomePriceIndexWizard.steps.propertyType.duplex',
    defaultMessage: 'Duplex'
  },
  mobileHomeOrManufactured: {
    id: 'HomePriceIndexWizard.steps.propertyType.mobileHomeOrManufactured',
    defaultMessage: 'Mobile'
  },
  coOp: {
    id: 'HomePriceIndexWizard.steps.propertyType.coOp',
    defaultMessage: 'Co-Op'
  },
  other: {
    id: 'HomePriceIndexWizard.steps.propertyType.other',
    defaultMessage: 'Other'
  }
})

const Slide = props => <SlideOnMount interval={50} top='-80px' {...props} />

export const PropertyType = ({ onComplete }: Step) => {
  const intl = useIntl()

  const context = useAvmModuleContext()

  // Hack to redirect user back to digest if widget is complete
  // Also guard against completing the wizard twice
  if (context.state.wizardCompletedAt) {
    return <RedirectToHomeDigest />
  }

  return (
    <Form onSubmit={onComplete} flex='1' display='flex' flexDirection='column' justifyContent='space-between'>
      <Slide>
        <Heading fontWeight='normal' mb='2'>
          {intl.formatMessage(MSG.heading)}
        </Heading>
        <Text mb='0'>{intl.formatMessage(MSG.subheading)}</Text>
      </Slide>
      <Slide>
        <Box marginTop='12'>
          <RadioGroup
            variant='button'
            colorScheme='primary'
            name='propertyType'
            defaultValue='singleFamilyDetached'
            tracking={{
              guid: 'aa3Y5QvdVzPgkAAeKuyVBn',
              ui_context:
                HomeownerDigestTrackingEventLocation.HOMEOWNER_DIGEST_HOME_PRICE_INDEX_WIZARD_PROPERTY_TYPE_STEP
            }}
          >
            <Wrap justify='center' maxWidth='350px' marginX='auto'>
              <WrapItem>
                <Radio value='singleFamilyDetached'>{intl.formatMessage(MSG.singleFamilyDetached)}</Radio>
              </WrapItem>
              <WrapItem>
                <Radio value='condo'>{intl.formatMessage(MSG.condo)}</Radio>
              </WrapItem>
              <WrapItem>
                <Radio value='townhouse'>{intl.formatMessage(MSG.townhouse)}</Radio>
              </WrapItem>
              <WrapItem>
                <Radio value='apartment'>{intl.formatMessage(MSG.apartment)}</Radio>
              </WrapItem>
              <WrapItem>
                <Radio value='duplex'>{intl.formatMessage(MSG.duplex)}</Radio>
              </WrapItem>
              <WrapItem>
                <Radio value='mobileHomeOrManufactured'>{intl.formatMessage(MSG.mobileHomeOrManufactured)}</Radio>
              </WrapItem>
              <WrapItem>
                <Radio value='coOp'>{intl.formatMessage(MSG.coOp)}</Radio>
              </WrapItem>
              <WrapItem>
                <Radio value='other'>{intl.formatMessage(MSG.other)}</Radio>
              </WrapItem>
            </Wrap>
          </RadioGroup>
        </Box>
      </Slide>
      <Spacer />
      <Slide>
        <Button
          type='submit'
          colorScheme='primary'
          width='100%'
          tracking={{
            guid: 'kJch6kV6NYkzatPaETA24d',
            descriptor: MSG.submit.defaultMessage,
            ui_context: HomeownerDigestTrackingEventLocation.HOMEOWNER_DIGEST_HOME_PRICE_INDEX_WIZARD_PROPERTY_TYPE_STEP
          }}
        >
          {intl.formatMessage(MSG.submit)}
        </Button>
      </Slide>
    </Form>
  )
}
